import React from 'react';
import { useTranslate } from 'ts/common/hooks';
import { useClientBookingExperience } from 'client_react/booking/ClientBookingExperience';
import { ClientPaymentOption } from 'client_react/common/components/ClientPaymentOptions';
import ClientPaymentSummary from 'client_react/common/components/ClientPaymentSummary';

interface Props {
    paymentAmountType: ClientPaymentOption;
}

const PaymentSummary = ({ paymentAmountType }: Props) => {
    const { bookingSession } = useClientBookingExperience();
    const t = useTranslate('booking.payment');

    if (!bookingSession) {
        return null;
    }

    const isFullPayment = paymentAmountType === 'full';

    const subtotal = isFullPayment ? bookingSession.price : bookingSession.retainerPaymentAmount;

    const salesTax = isFullPayment
        ? bookingSession.salesTaxForPrice
        : bookingSession.salesTaxForRetainerPaymentAmount;

    const totalPrice = isFullPayment
        ? bookingSession.priceWithSalesTax
        : bookingSession.retainerPaymentAmountWithSalesTax;

    return (
        <ClientPaymentSummary
            showBreakdown={bookingSession.isTaxable}
            salesTax={salesTax}
            salesTaxSubtitle={bookingSession.salesTaxTitle || t('paymentSummaryTax')}
            subtotal={subtotal}
            subtotalSubtitle={t('paymentSummarySubtotal')}
            title={t('paymentSummary')}
            totalPrice={totalPrice}
            totalSubtitle={t('paymentSummaryTotal')}
        />
    );
};

export default PaymentSummary;
